<script>
  import { getContext } from "svelte";

  import Bleed from "./Bleed.svelte";
  import Heading from "./Heading.svelte";
  import Markdown from "./Markdown.svelte";
  import EmailSignupForm from "$lib/contentTypes/EmailSignupForm.svelte";

  export let image;
  export let actions;
  export let fullWidth = true;
  export let componentMap;

  function getComponent(typename) {
    let component = componentMap[typename];
    if (!component) {
      // eslint-disable-next-line no-console
      console.warn(`Component missing: ${typename}`);
    }
    return component;
  }

  const containerized = getContext("containerized");
  if (containerized) {
    fullWidth = false;
  }

  export let backgroundColor = true;
  export let title = "";
  export let description = "";
  /** @type {"left" | "centered"} */
  export let actionAlignment = "left";

  export let containerClass = "";
  export let bodyClass = "";
  export let titleClass = "";
  export let descriptionClass = "";

  const alignmentClassMap = {
    left: "",
    centered: "flex-col md:flex-row justify-center items-center md:items-start"
  };

  containerClass += backgroundColor ? "bg-indigo-50 md:py-72" : "";
  let containsFirstEmailSignUp = actions
    ? actions[0]?.sys.contentType.sys.id === "emailSignup"
    : false;
  const itemAlignment = containsFirstEmailSignUp ? "items-start" : "items-center";
</script>

<Bleed {fullWidth} fullWidthClasses={containerClass}>
  <div class="flex flex-col md:flex-row justify-center {itemAlignment}">
    {#if image}
      <img
        class="grow flex-shrink-0 w-full md:w-1/3 aspect-[4/3] object-cover"
        src={image.fields.imageAsset.fields.file.url}
        alt={image.fields.altText}
      />
    {/if}

    <div
      class="grow flex flex-col {!containerized
        ? 'px-24 lg:pl-48 lg:pr-72'
        : ''} md:py-0 lg:justify-center gap-24 {bodyClass}"
      class:py-24={image || backgroundColor}
    >
      {#if title}
        <Heading class="text-size-20 font-bold {titleClass}" text={title} />
      {/if}

      {#if description}
        <div class={descriptionClass}><Markdown input={description} /></div>
      {/if}

      <div class="flex {alignmentClassMap[actionAlignment]} gap-x-72 gap-y-24">
        {#if actions?.length > 0}
          {#each actions as action}
            {@const sharedProps = {
              data: action.fields,
              class: "w-fit",
              id: `cta-${action.sys.id}`,
              forceVerticalAlignment: !!image
            }}
            {#if action.sys.contentType.sys.id === "emailSignup"}
              <EmailSignupForm bind:description {...sharedProps} />
            {:else}
              <svelte:component
                this={getComponent(action.sys.contentType.sys.id)}
                {...sharedProps}
              />
            {/if}
          {/each}
        {/if}
      </div>
    </div>
  </div>
</Bleed>
